<template>
  <div v-if="loaded" class="ration-info-dialog">
    <div class="title" :title="name">{{ shortVersion(name) }}</div>
<!--    <span @click="closeDialog"-->
<!--      class="i-util-close-dialog icon"></span>-->
    <table>
      <thead>
        <th>{{ 'base.ingredient' | translate }}</th>
        <th>{{ 'modals.ration_info.first' | translate }}</th>
        <th>{{ 'modals.ration_info.second' | translate  }}</th>
        <th>{{ 'modals.ration_info.third' | translate }}</th>
      </thead>
      <tbody>
        <tr v-for="item in items" :key="item.id">
          <td :title="item.name">{{ shortVersion(item.name) }}</td>
          <td>{{ item.plan_value }} / {{ item.fact_value }}</td>
          <td>{{ (item.plan_value * item.dry_matter / 100).toFixed(2) }} / 
            {{ item.fact_value !== '-' ? (item.fact_value * item.dry_matter / 100).toFixed(2) : '-' }}</td>
          <td>{{ item.plan_weight.toFixed(0) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'RationInfoDialog',

  props: {
    id: Number
  },

  mounted () {
    this.loadData()
  },

  data: () => ({
    items: [],
    name: '',
    animalCount: 0,
    loaded: false
  }),

  methods: {
    async loadData () {
      const { data } = await api.schedule.getById(this.id)
      this.items = data.schedule_ration.ingredients
      this.name = data.schedule_ration.name
      data.schedule_groups.forEach(element => {
        this.animalCount += element.animal_count
      })
      this.items.forEach(element => {
        element.plan_value = +(element.plan_weight / this.animalCount).toFixed(2)
        element.fact_value = (element.fact_weight ? +(element.fact_weight / this.animalCount).toFixed(2) : '-')
      })
      this.loaded = true
    },

    closeDialog () {
      this.$emit('on-close')
    },

    shortVersion (str) {
      return str.length > 20 ? (str.substring(0, 20) + '...') : str
    }
  }
}
</script>

<style scoped>
.ration-info-dialog {
  position: relative;
  width: 660px;
  height: auto;
  background: #fff;
  border-radius: 10px;
  padding-top: 26px;
  padding-left: 29px;
  padding-bottom: 10px;
}

.icon {
  position: absolute;
  cursor: pointer;
  right: 15px;
  top: 15px;
}

.title {
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 21px;
}

table {
  width: 100%;
  text-align: left;
  border-spacing: 0;
}

th {
  font-size: 13px;
  font-weight: normal;
  font-weight: 300;
  color: #979797;
  vertical-align: top;
  padding-bottom: 10px;
}

td {
  font-size: 15px;
  padding-top: 16px;
  padding-bottom: 16px;
  border-top: 1px solid rgba(215, 215, 215, 0.5);
}
</style>
